export default __webpack_public_path__ + "static/media/Deep1.b3a312d8.jpeg";